import { IsString, IsIn, IsNumber, IsOptional } from 'class-validator';

export class MeasurementBaseConfigDTO {
    @IsString()
    field!: string;

    @IsIn(['s', 'n'])
    type!: 's' | 'n';

    @IsString()
    endDate!: string;

    @IsString()
    assignmentToken!: string;

    @IsString()
    macAddress!: string;

    @IsString()
    locationId!: string;

    @IsString()
    tenantId?: number;
}

export class ListMeasurementsDTO extends MeasurementBaseConfigDTO {
    @IsString()
    startDate!: string;

    @IsString()
    tenantType?: string;
}

export class AggregatedMeasurementsDTO extends MeasurementBaseConfigDTO {
    @IsIn(['avg', 'mean', 'min', 'max', 'sum'])
    method!: 'avg' | 'mean' | 'min' | 'max' | 'sum';

    @IsNumber()
    @IsOptional()
    cumulative!: number;

    @IsString()
    startDate!: string;

    @IsString()
    tenantType?: string;
}

export class ListAggregatedMeasurementsDTO extends AggregatedMeasurementsDTO {
    @IsString()
    @IsOptional()
    groupBy!: string;
}

export class LastValueConfigDTO extends MeasurementBaseConfigDTO {
    @IsString()
    @IsIn(['lastValue'])
    method!: 'lastValue';

    @IsNumber()
    cumulative!: number;

    @IsString()
    tenantType?: string;
}

export interface MeasurementMultiple {
    locations: MeasurementLocation[];
}

export interface MeasurementLocation {
    locationId: string;
    devices: MeasurementDevice[];
}

export interface MeasurementDevice {
    assignmentToken: string;
    macAddress: string;
    field: string;
    type: string;
    cumulative: string;
    endDate: string;
}
